import { Constants } from './v2-fgen-constants.js';
import { FEngineException, fe$utils } from './v2-fgen-fengine.js';
import { FormCookies, setCookie } from './v2-fgen-extensions.js';

import {
   fet$unexpectedError, fet$showSubmitSuccess, fet$redirect,
   fet$showSubmitError, fet$onSubmit, fet$langsAvailable, fet$onRendering,
   fet$onProgress, fet$onValidationPerformed, fet$onUnrecoverableError
} from './v2-fgen-form.js';

console.log('[FE_c] V 1.0.19');

   var validationCallback = null;
   var source = null;
   var seed = 0;
   var _endpoint = '/services/apexrest/public/persona';
   var _attachEndpoint = '/services/apexrest/public/attach';

   window.proxyTimeout = null;
   let _progressProxyTotal = 0;
   let _progressProxyError = null;
   let _progressProxyLast = 0;
   let _progressProxyURI = 0;
   let _progressErrorTry = 0;

   var _sendMethod = 'POST';
   var _sendId = '';

   var unrecovErrShown = null;
   // Array of functions to execute on submit
   var submitChain = new Array();

   window.fe$getSubmitChain = () => submitChain;
   window.fe$setCookie = (args) => setCookie(...args);

   function dataProviderFnc(parameters, datasource, caller, callback, extUrl) {

      var fixCallback = function (callback, code, dataOrMessage, reqId) {
         if (code == crm.ajax.CODE_SUCCESS) {
            // If success delegate call

            callback(dataOrMessage);
         } else if (code == crm.ajax.CODE_CALL_OVERRIDEN) {
            // If overriden ignore...next one will arrive
            console.log('[FE_A] Ignored data provider call..overriden');
         } else {
            // Other errors...show as unexpected
            fet$unexpectedError(dataOrMessage);
         }
      }.bind(this, callback);
      var reqId = 'dpReq' + (seed++);
      console.log('[FE_A] Calling datasource ' + datasource + ' with reqId ' + reqId, extUrl);
      if (extUrl) {
         crm.ajax.getInstance().getExtDataSourceInfo(extUrl, parameters, datasource, source, caller, fixCallback, reqId);
      } else {
         crm.ajax.getInstance().getDataSourceInfo(parameters, datasource, source, caller, fixCallback, reqId);
      }
   }

   function prepareForPut(initializeBlock) {
      _sendMethod = 'PUT';

      var param = initializeBlock.parameters.find(p => p.sendAs === 'contactId');

      if (param.value && param.value.charAt(0) == "'") {
         //we have the ID in the Source but we need to remove the ''
         _sendId = param.value.slice(1, -1);

      } else if (param.value && param.value.startsWith('request.')) {
         //we have the ID in the request
         const urlParams = new URLSearchParams(window.location.search);

         _sendId = urlParams.get(param.value);

         if (!_sendId) {
            console.log('[FE_CTR] Cannot get ID for PUT configuration');
            _sendMethod = 'POST';
         }

      } else {
         console.log('[FE_CTR] Cannot get ID for PUT configuration');
         _sendMethod = 'POST';
      }

   }

   function render(data) {
      var langs = fe$ngine.getLangsForDef(data);
      console.log('[FE_A] Obtained langs: ' + langs);
      
      fe$ngine.setLanguage(fe$utils.getUrlParameter('lang') || data?.defLang || window?.lang || document?.documentElement?.lang || fe$ngine.getDefaultLangForDef(data));

      var lang = fe$ngine.getLanguage();

      if (typeof fet$langsAvailable != 'undefined') {
         fet$langsAvailable(langs, lang);
      }
      

      //Check if expired
      if (data.expired) {
         if (data.form.ifExpired && data.form.ifExpired.length) { //Consultamos si existe el array de customizaciones ifExpired en la definición del formulario
            // 1. Recuperamos la label del título y subtítulo personalizados en caso de que el formulario haya expirado
            let expiredTitle = data.form.ifExpired.find(element => element.label === "#label.expired.title")?.label;
            let expiredSubtitle = data.form.ifExpired.find(element => element.label === "#label.expired.subtitle")?.label;

            // 2. Si existen los mensajes personalizados, los insertamos en el Título y Subtítulo de la página en lugar de los valores por defecto
            document.getElementById("title").innerHTML = expiredTitle ? data.translations[expiredTitle][lang] : Constants.FORM_TITLE_EXPIRED[lang];
            document.getElementById("form").innerHTML = expiredSubtitle ? data.translations[expiredSubtitle][lang] : Constants.FORM_LABEL_EXPIRED[lang];
         } else {
            document.getElementById("title").innerHTML = Constants.FORM_TITLE_EXPIRED[lang];
            document.getElementById("form").innerHTML = Constants.FORM_LABEL_EXPIRED[lang];
         }
         return;
      }

      // Check whether there is a new endpoint defined and therefore override the persona one
      if ('meta' in data && 'endpoint' in data.meta) {
         _endpoint = data.meta.endpoint;
         console.log('[FE_A] Overrided endpoint with ' + _endpoint);
      }

      //Inicialización del engine
      fe$ngine
         .setValidationCallback(fet$onValidationPerformed)
         .setRenderCallback(fet$onRendering)
         .setUnexpectedCallback(fet$unexpectedError)
         .setSubmitCallback(onSubmit)
         .setLangChangeCallback(onLangChange)
         .setDataProvider(dataProviderFnc)
         .setShowSuccessService(fet$showSubmitSuccess)
         .setRedirectionService(fet$redirect);

      FormCookies(data);

      //Render
      fe$ngine
         .initialize()
         .render(data);

      // Prepare after submit steps
      buildSubmitChain();

      if ('meta' in data && 'initialize' in data.meta) {
         // Required initialization
         fe$ngine.lock(true);
         loadInitializationData(data.meta.initialize);

         // If we are initializing a Contact then send method must be a PUT
         if (data.meta.initialize && data.meta.initialize.key == 'Contact') {
            prepareForPut(data.meta.initialize);
         }
      }
   }

   /**
    * Function that prepares all the calls that are required on the submit for the rendered form
    */
   function buildSubmitChain() {
      submitChain.push(submitFormData);
      if (fe$ngine.hasInternalUploads()) {
         submitChain.push(attachInternalFiles);
      }
      var extDestinations = fe$ngine.getUploadExternalDestinations();
      for (var i = 0; i < extDestinations.length; i++) {
         console.log('[FEC] Included attachExternalFiles for destination ' + extDestinations[i] + ' in submit chain');
         submitChain.push(attachExternalFiles.bind(this, extDestinations[i]));
      }
      submitChain.push(finishSubmitChain);
   }

   function onSubmitResult(callback, context, code, errorOrData) {
      console.log('[FEA] Obtained response: ' + code + ': ' + JSON.stringify(errorOrData));

      context.form = {};
      context.form.code = code;
      context.form.errorOrData = errorOrData;
      if (code === crm.ajax.CODE_SUCCESS) {
         // Call next on chain
         fe$ngine.onExternalEvent('change', 'response', context.form.errorOrData);
         callback();
      } else {
         context.success = false;
         context.message = errorOrData;
         finishSubmitChain(callback, context);
      }
   }
   /**
    * Chained method that closes the submit chain
    */
   function finishSubmitChain(callback, context) {
      console.log('[FEA] finishSubmitChain --- ', context);
      fe$ngine.lock(false);
      fe$utils.removeClass('submitting', document.body);
      if (submitChain.length > 2 && window.fet$onProgress) {
         fet$onProgress(1, fe$ngine.getTranslationFor('#&progress.closing', 'Closing'));
      }
      if (!context.success) {
         resolveSubmitError(context.form.code, context.message);
      } else {
         console.log('[FEC] finishChain --- invoked with context', context);

         // Push datalayer info
         if (typeof dataLayer != 'undefined') {
            var data = {
               'event': 'event.generic',
               'eventCategory': 'registro formularios',
               'eventAction': fe$utils.getUrlParameter('idf'),
               'eventLabel': window.location.href + '&lang=' + fe$ngine.getLanguage()
            };

            console.log('[FEA] Pushing datalayer info: ' + JSON.stringify(data));

            dataLayer.push(data);
         }

         fe$ngine.resolveSuccess();
      }
   }

   function resolveSubmitError(code, error) {
      // Check if error is recoverable or not...
      if (!code || code.indexOf('UE_') != 0) {
         fet$showSubmitError(error);
      } else { // Unrecoverable error
         // Try to search a translation for the error code
         console.log('[FEA] Obtained error ' + code + ' - ' + error);
         unrecovErrShown = code;
         fet$onUnrecoverableError(unrecovErrShown, fe$ngine.getTranslationFor('#&error.unrecoverable.' + unrecovErrShown));
      }
   }

   function onLangChange(newLang) {
      lang = newLang;
      console.log('[FEA] Lang change detected');
      if (unrecovErrShown) {
         fet$onUnrecoverableError(unrecovErrShown, fe$ngine.getTranslationFor('#&error.unrecoverable.' + unrecovErrShown));
      }
   }

   function fet$progressProxy(destination, id, amount, message) {
      if (proxyTimeout) {
         clearTimeout(proxyTimeout);
         proxyTimeout = null;
      }
      _progressProxyURI = destination + '?contactId=' + id;
      fetch(_progressProxyURI)
         .then(response => response.json())
         .then(data => {
            _progressProxyLast = data.uploaded;
            _progressProxyTotal = data.total;

            document.dispatchEvent(new CustomEvent('onProxyProgress', {
               detail: {
                  destination: destination,
                  id: id,
                  error: data.error,
                  amount: amount,
                  message: message,
                  total: data.total,
                  uploaded: data.uploaded
               }
            }));


            if (data.error || !data.total) {
               ++_progressErrorTry;

               if (_progressErrorTry > 10) { //fin
                  _progressProxyError = data.error;
                  return;
               }
            } else if (data.uploaded >= data.total) { //fin
               return;
            }

            proxyTimeout = setTimeout(() => {
               fet$progressProxy(destination, id, amount, message);
            }, 2000);
         })
         .catch(error => {
            _progressProxyError = error;
            console.log("[DJF] progressProxy ERROR: " + JSON.stringify(error));
         })
   }

   function fet$onFilesOnProxy(event) {
      console.log("[DJF] files on proxy! clientId:" + event.detail.id);
      //Wait 4s before the first progress call 
      setTimeout(() => fet$progressProxy(event.detail.destination, event.detail.id, event.detail.amount, event.detail.message + ' al nùvol', null), 4000);
   }

   function fet$ProgressOnProxyProgress(event) {
      if (event.detail.error) {
         return;
      }
      let percent = event.detail.total ? (event.detail.uploaded / event.detail.total) / fe$getSubmitChain().length : 0;
      window.fet$onProgress && fet$onProgress(event.detail.amount + percent, event.detail.message);
   }

   function _callProgress() {
      return new Promise((resolve, reject) => {
         setTimeout(() => { // wait two seconds between calls
            fetch(_progressProxyURI)
               .then(response => response.json())
               .then(data => resolve(data))
               .catch(e => reject(e));
         }, 2000);
      })
   }

   async function onErrorCheckUploadProgress(rq) {


      let status = rq.status;
      //Make sure the server is reachable
      if (_progressProxyError != null || (_progressProxyTotal == 0 && !(status >= 200 && status < 300 || status === 304))) {
         return { success: false };
      } else {

         try {
            let attempts = 0;

            while (_progressProxyError == null) {
               var data = await _callProgress(); //This make a call each 2 seconds
               if (data.error) {
                  if (attempts > 2) {
                     return { success: false };
                  }
                  ++attempts;
               } else if (data.uploaded >= data.total) {
                  return { success: true };
               } else if (data.uploaded > _progressProxyLast) { // progressing
                  continue;
               } else {
                  return { success: false };
               }
            }
         } catch (e) {
            return { success: false };
         }

      }

   }

   document.addEventListener('onProxyProgress', (e) => fet$ProgressOnProxyProgress(e));
   document.addEventListener('filesOnProxy', (e) => fet$onFilesOnProxy(e));


   var ATTEMPTS_EXTERNAL_MAX = 2;
   var defaultLang = document.documentElement.lang ? document.documentElement.lang : 'es';

   function onAttachedExternalFiles(callback, context, attempts, destination, formData, rq) {

      if (rq.readyState == 4) {
         console.log('[FEC] External upload response; ' + rq.status);
         var retry = false;
         var failed = false;
         var error = null;
         var data = null;
         var recoverable = true;
         if (rq.status < 200 || rq.status >= 400) {
            console.log('[FEC] Obtained error server status ' + rq.status);
            failed = true;

         } else {
            data = JSON.parse(rq.responseText);
            if (data.code != 'ok') {
               failed = true;
               error = data.message;
               recoverable = (data.recoverable != false);
               console.log('[FEC] Recoverable? ' + recoverable);
            }
         }
         if (failed) {

            onErrorCheckUploadProgress(rq)
               .then(progressData => {

                  if (progressData.success) {
                     callback();
                     return;
                  }

                  attempts++;
                  if (recoverable && attempts < ATTEMPTS_EXTERNAL_MAX
                     && confirm(fe$ngine.getTranslationFor('#&progress.uploading.error', 'Problems sending file. Wanna try again?'))) {
                     retry = true;
                  }
                  if (retry) {
                     rq = new XMLHttpRequest();
                     rq.open("POST", destination);
                     rq.onreadystatechange = onAttachedExternalFiles.bind(this, callback, context, attempts, destination, formData, rq);
                     rq.send(formData);
                  } else {
                     if (rq.status == 0) {
                        console.log('[FEC] Set error to connectivity problem');
                        error = fe$ngine.getTranslationFor('#&error.connectivity',
                           (defaultLang == 'ca' ? 'Error de connexió' : defaultLang == 'pt' ? 'Erro de conexão' : 'Error de conexión')); //"Connectivity error";
                     } else {
                        console.log('[FEC] Set error to unexpected problem');
                        error = fe$ngine.getTranslationFor('#&error.unexpected',
                           (defaultLang == 'ca' ? 'Error inesperat' : defaultLang == 'pt' ? 'Erro inesperado' : 'Error inesperado'));//"Unexpected error";
                     }
                     context.success = false;
                     context.message = error;
                     finishSubmitChain(callback, context);
                  }
               })
               .catch(error => {
                  console.log('[FEC] Set error to connectivity problem =>' + error);

                  error = fe$ngine.getTranslationFor('#&error.connectivity',
                     (defaultLang == 'ca' ? 'Error de connexió' : defaultLang == 'pt' ? 'Erro de conexão' : 'Error de conexión')); //"Connectivity error";


                  context.success = false;
                  context.message = error;
                  finishSubmitChain(callback, context);
               })

         } else {
            callback();
         }
      }

   }
   function attachExternalFiles(destination, callback, context) {
      console.log('[FEC] attachExternalFiles -- for destination ' + destination + ' with context', context);
      if (fe$ngine.countAttachedFilesForDestination(destination) == 0) {
         callback();
         return;
      }
      var descs = fe$ngine.getFileValuesForDestination(destination, true);
      console.log('[FEC] File values for destination ' + destination, descs);
      var fd = new FormData();

      var params = fe$ngine.getParametersForUploadDestination(destination, false);
      for (var k in params) {
         fd.append(k, params[k]);
      }

      for (var i = 0; i < descs.length; i++) { // For each control we iterate over files
         fe$ngine.getParametersForDestination
         for (var j = 0; j < descs[i].files.length; j++) {
            var file = fe$ngine.getFileHandlerForControlAndIndex(descs[i].name, j);
            console.log('[FEC] File handler:', file);
            fd.append("file_" + descs[i].name + "_" + j, file);
         }
      }
      if (window.fet$onProgress) {
         fet$onProgress(context.progress, fe$ngine.getTranslationFor('#&progress.uploading', 'Uploading'));
      }
      var rq = new XMLHttpRequest();
      rq.open("POST", destination);

      rq.upload.onprogress = (evt) => {
         if (evt.lengthComputable) {
            var percentComplete = evt.loaded / evt.total;
            console.log('[FEC] Ajax progress: ' + Math.round(percentComplete * 1000) / 10 + '%');
            if (window.fet$onProgress) {
               var amount = context.progress + context.stepProgress * percentComplete;
               var message = fe$ngine.getTranslationFor('#&progress.uploading', 'Uploading');
               fet$onProgress(amount, message);

               // this code is only for conciertos participativos 
               // 
               if (evt.loaded == evt.total) {
                  document.dispatchEvent(new CustomEvent('filesOnProxy', {
                     detail: {
                        destination: destination,
                        id: context.form.errorOrData.id,
                        amount: amount,
                        message: message
                     }
                  }));
               }
            }
         } else {
            console.log('[FEC] Ajax progress: not computable');
         }
      }
      rq.onreadystatechange = onAttachedExternalFiles.bind(this, callback, context, 0, destination, fd, rq);
      rq.send(fd);

   }

   function onAttachedInternalFile(callback, context, currIdx, files, code, errorOrData) {
      console.log('[FEA] Progress attach internal: ' + currIdx + '/' + files.length, files);
      if (code !== crm.ajax.CODE_SUCCESS) {
         console.log('[FEA] Problems attaching file....' + JSON.stringify(errorOrData) + ' - context: ' + JSON.stringify(context));
         // TODO: Allow resending...
         var failureMsg = fe$ngine.getTranslationFor('#&error.upload.retry', 'File {0} failed to upload. Do you want to retry?');
         console.log('[FEC] Obtained failure message: "' + failureMsg + '"')
         failureMsg = failureMsg.replace(/\{0}/, files[currIdx].attachment.file);
         if (confirm(failureMsg)) {
            sendInternalFile(files[currIdx], context.form.errorOrData.id, onAttachedInternalFile.bind(this, callback, context, currIdx, files));
            return;
         }
      }

      if (window.fet$onProgress) {
         var text = fe$ngine.getTranslationFor('#&progress.fileattached', 'File {0} attached');
         text = text.replace(/\{0}/, files[currIdx].attachment.file);
         fet$onProgress(context.progress + context.stepProgress * (currIdx + 1) / files.length, text);
      }
      if (currIdx < files.length - 1) {
         // Do next one
         console.log('[FEA] Submitted ' + currIdx + ' files. Sending ' + (currIdx + 1));
         sendInternalFile(files[currIdx + 1], context.form.errorOrData.id, onAttachedInternalFile.bind(this, callback, context, currIdx + 1, files));
      } else {
         console.log('[FEA] Submitted ' + currIdx + ' files of ' + files.length + '. Ending...');
         callback();
      }
   }

   /**
    * Chained method that sends attached files to salesforce
    */
   function attachInternalFiles(callback, context) {
      console.log('[FEC] attachInternalFiles --- with context', context);
      var attachedFiles = fe$ngine.countAttachedFilesForDestination(undefined);
      // If submit didn't succeeded no need to attach..go on
      if (context.form.code !== crm.ajax.CODE_SUCCESS) {
         console.log('[FEC] Detected problem in form submit...skipping attaching');
         callback();
         return;
      }
      // If no files attached go on
      if (attachedFiles == 0) {
         console.log('[FEC] No form files...skipping');
         callback();
         return;
      }

      console.log('[FEC] Found ' + attachedFiles + ' attached files');
      var filesInfo = fe$ngine.getFileValuesForDestination(undefined, true);
      var fileDescs = new Array();


      for (var i = 0; i < filesInfo.length; i++) {
         console.log('[FEA] Files under name: ' + filesInfo[i].name);
         for (var j = 0; j < filesInfo[i].files.length; j++) {
            fileDescs.push({ "compName": filesInfo[i].name, "attachment": filesInfo[i].files[j] });
         }
      }

      console.log('[FEA] Attaching ' + filesInfo.length + ' files');
      if (window.fet$onProgress) {
         fet$onProgress(context.progress, fe$ngine.getTranslationFor('#&progress.recordcreated', 'Record created'));
      }

      sendInternalFile(fileDescs[0], context.form.errorOrData.id, onAttachedInternalFile.bind(this, callback, context, 0, fileDescs));

   }

   function sendInternalFile(fileDesc, toId, callback, idFuente, compName) {
      var fileDescAttachment = fileDesc.attachment;
      var fileDescCompName = fileDesc.compName;
      console.log('[FEA] Attaching file ' + JSON.stringify(fileDescAttachment));
      var endpoint = _attachEndpoint + '/' + toId;
      // var data = btoa(fileDesc.data);
      console.log('[FEA] Sending data: ', fileDescAttachment.data);
      var idFuente = fe$utils.getUrlParameter('idf');
      crm.ajax.getInstance().sendFile(fileDescAttachment.file, fileDescAttachment.data, idFuente, fileDescCompName, endpoint, callback);

   }

   function doSubmitChain(index, context) {
      console.log('[FEC] Doing submit chain with index ' + index + ' and context: ', context);
      if (index >= submitChain.length) {
         console.log('[FEC] Finished submit chain');
         return;
      }
      if (!context.success) {
         resolveSubmitError(context.form.code, context.message);
      }
      context.progress = index * context.stepProgress;
      submitChain[index](doSubmitChain.bind(this, index + 1, context), context); // Call next in chain
   }

   /**
    * Chained method that sends form data
    */
   function submitFormData(callback, context) {
      console.log('[FEC] submitFormData --- with context ', context);
      var errs = fe$ngine.isValid()
      if (fe$utils.isDictEmpty(errs)) {
         fe$ngine.lock(true);
         if (fet$onSubmit) {
            fet$onSubmit();
         }
         fe$utils.addClass('submitting', document.body);
         var formData = fe$ngine.getValues();

         if (submitChain.length > 2 && window.fet$onProgress) {
            fet$onProgress(context.progress, fe$ngine.getTranslationFor('#&progress.initializing', 'Initializing'));
         }

         if (_sendMethod == 'POST') {
            crm.ajax.getInstance().sendData(source, formData, _endpoint, onSubmitResult.bind(this, callback, context), 'FE');
         } else {
            crm.ajax.getInstance().sendData(source, formData, _endpoint, onSubmitResult.bind(this, callback, context), 'FE', _sendMethod, _sendId);
         }
      }
   }

   function onSubmit() {
      var context = {
         success: true,
         stepProgress: 1.0 / submitChain.length
      }

      doSubmitChain(0, context);
   }



   function loadInitializationData(initializeBlock) {
      var key = initializeBlock.key;

      var endpoint = '/services/apexrest/public/sourceData/' + source + '/' + key;
      var params = '';
      var initialize = true;
      console.log('[FE_CTR] Initializing form with config: ' + JSON.stringify(initializeBlock));
      console.log('[FE_CTR] Number of params: ' + initializeBlock.parameters.length);
      for (var i = 0; i < initializeBlock.parameters.length; i++) {
         var paramCfg = initializeBlock.parameters[i];
         console.log('[FE_CTR] Checking initialization param ' + JSON.stringify(paramCfg));
         var param = null;
         var data = paramCfg.value;
         console.log('[FE_CTR] Param ' + paramCfg.value);
         if (data.charAt(0) == "'") {
            param = paramCfg.sendAs + '=' + data.substring(1, data.length - 1);
         } else if (data.indexOf('request.') == 0) {
            var value = fe$utils.getUrlParameter(data.substring('request.'.length, data.length));
            console.log('[FE_CTR] Param ' + paramCfg.value + ' value is ' + value);
            if (value != null) {
               param = paramCfg.sendAs + '=' + value;
            } else {
               // Check if we have to desist
               if (paramCfg.ifNoValue == 'skip') {
                  initialize = false;
                  break;
               } else if (paramCfg.ifNoValue == 'error') {
                  fet$unexpectedError('Parameter ' + paramError + ' not received. Unable to continue');
                  initialize = false;
                  break;
               } else if ('ifNoValue' in paramCfg && paramCfg.ifNoValue != 'continue') {

               }
            }
         } else {
            // Place it as it is
            param = paramCfg.sendAs + '=' + data;
         }
         if (param != null) {
            console.log('[FE_CTR] Appending param ' + param);
            if (params.length == 0) {
               params += '?';
            } else {
               params += '&';
            }
            params += param;
         }
      }

      if (initialize) {
         console.log('[FE_CTR] Initializing with key ' + key + ' and params: ', params);
         crm.ajax.getInstance().getData(endpoint + params, onInitializationDataReceived, 'rqInit');
      } else {
         console.log('[FE_CTR] Skipped initialization...not all criteria was met');
         fe$ngine.lock(false);
      }

   }
   function onInitializationDataReceived(code, dataOrError) {
      console.log('[FE_CTR] Obtained initialization data: ' + code);
      if (code === crm.ajax.CODE_SUCCESS) {
         var fieldValues = dataOrError.data;
         fe$ngine.setValues(fieldValues);
         fe$ngine.lock(false);
      } else {
         if (code === 'SECURITY') {
            fet$unexpectedError('Invalid parameters');
         } else if (code == 'NO_DATA') { // Ignore...the system no longer contains that data...so just don't initialize
            fe$ngine.lock(false);
         } else {
            fet$unexpectedError('Problems loading form values: ' + dataOrError);
         }
      }
   }
   function onFormConfigReceived(code, dataOrError) {
      console.log('[FE_CTR] Obtained gen form data: ' + code);
      if (code === crm.ajax.CODE_SUCCESS) {
         console.log('[FE_CTR] Obtained data: ' + JSON.stringify(dataOrError.form));
         var data = JSON.parse(dataOrError.form);
         console.log('[FE_CTR] Form config: ' + JSON.stringify(data));
         render(data);
      } else {
         console.log('[FE_A] Obtained error: ' + JSON.stringify(dataOrError));
         fet$unexpectedError(dataOrError);
      }
   }



   document.addEventListener('DOMContentLoaded', function () {

      var env = fe$utils.getUrlParameter('env')
         || 'prod'

      var proxy = fe$utils.getUrlParameter('proxy')
         || 'https://cloud.news.fundacionlacaixa.org/v2-fgen-feproxy';

      crm.ajax.getInstance()
         .configureDataProxy(proxy)
         .configureDataProxyEnv(env)
         .configureDestination(targeturl);

      console.log('Configured ajax destination');

      source = fe$utils.getUrlParameter('idf')
         || 'noForm';


      if (typeof fet$showSubmitSuccess == 'undefined') {
         throw new FEngineException('fet$showSubmitSuccess not defined');
      }

      if (typeof fet$unexpectedError == 'undefined') {
         throw new FEngineException('fet$unexpectedError not defined');
      }

      if (typeof localConfig !== 'undefined') {
         console.log('[FE_A] Using local configuration');
         render(localConfig);
      } else {
         console.log('[FE_A] Retrieving form data for source ' + source);
         crm.ajax.getInstance().getGenForm(source, onFormConfigReceived);
      }
   });



